export default __webpack_public_path__ + "static/media/no-delivery-truck.d0a2ea1e.svg";